// extracted by mini-css-extract-plugin
module.exports = {"reportSkeleton":"report-skeleton_reportSkeleton__36omG","imageContent":"report-skeleton_imageContent__juFjJ","imageWrapper":"report-skeleton_imageWrapper__3cMz4"};